/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Режим работы терминала
 */
export type TerminalScheduleItem = {
  /**
   * День недели
   */
  dayOfWeek: TerminalScheduleItem.dayOfWeek
  /**
   * Время начала работы
   */
  from?: string
  /**
   * Время окончания работы
   */
  to?: string
}
export namespace TerminalScheduleItem {
  /**
   * День недели
   */
  export enum dayOfWeek {
    MON = 'mon',
    TUE = 'tue',
    WED = 'wed',
    THU = 'thu',
    FRI = 'fri',
    SAT = 'sat',
    SUN = 'sun'
  }
}
